import { z } from 'zod'

const phoneSchema = z
  .string()
  .regex(/^\d{10}$/, 'phone_number must be 10 digits')

export const otpRequestSchema = z
  .object({
    phone_number: phoneSchema.optional(),
    email: z.string().email().optional(),
  })
  .refine(value => Boolean(value.phone_number || value.email), {
    message: 'phone_number or email is required',
  })

export const otpVerifySchema = z
  .object({
    phone_number: phoneSchema.optional(),
    email: z.string().email().optional(),
    otp: z.string().length(6),
  })
  .refine(value => Boolean(value.phone_number || value.email), {
    message: 'phone_number or email is required',
  })

export type OtpRequestInput = z.infer<typeof otpRequestSchema>
export type OtpVerifyInput = z.infer<typeof otpVerifySchema>

export type OtpVerifyResponse = {
  token: string
}

export type MeResponse = {
  id: string
  email: string
  created_at: string
}
